module.exports = __webpack_public_path__ + "static/media/201.9789eb96.jpg";